import { axiosInstance } from "@/helper/axios-instance";
import type { Dictionary, DataAwareResponse } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useDictCreation() {
  return useMutationWithValidation({
    mutationFn: async (data: Partial<Dictionary>) => {
      const response = await axiosInstance({
        method: "PUT",
        url:  `Dictionary/insert`,
        data: data,
      });

      return response.data as DataAwareResponse<Dictionary>;
    },
    retry: 2,
    customMessage: {
      success: "Dictionary created successfully",
    },
  });
}
